// Dev Chat–specific tool enable toggle: RevoltButton with explicit On/Off label

import React from 'react';
import { RevoltButton } from '../../../../../components';
import './DesktopDevChatToolToggle.css';

/**
 * @param {Object} props
 * @param {boolean} props.active - Tool enabled for the next model call
 * @param {string} props.toolId - Short id shown as main text (e.g. get_time)
 * @param {string} [props.description] - Tooltip
 * @param {boolean} [props.disabled]
 * @param {Function} [props.onToggle] - (nextActive: boolean) => void
 */
export function DesktopDevChatToolToggle({
  active = false,
  toolId,
  description,
  disabled = false,
  onToggle,
}) {
  const label = toolId || 'tool';

  return (
    <RevoltButton
      type="button"
      variant={active ? 'primary' : 'outline'}
      size="sm"
      disabled={disabled}
      title={description || (active ? `${label} · enabled for model` : `${label} · disabled`)}
      aria-pressed={active}
      className={`desktop-dev-chat-tool-toggle${active ? ' desktop-dev-chat-tool-toggle--on' : ' desktop-dev-chat-tool-toggle--off'}`}
      onClick={() => !disabled && onToggle?.(!active)}
    >
      <span className="desktop-dev-chat-tool-toggle__name">{label}</span>
      <span className="desktop-dev-chat-tool-toggle__sep" aria-hidden>
        ·
      </span>
      <span className="desktop-dev-chat-tool-toggle__state">{active ? 'On' : 'Off'}</span>
    </RevoltButton>
  );
}
